enum SearchParams {
  PROCEDURE_ID = 'procedureId',
}

export default SearchParams;
